export default __webpack_public_path__ + "static/media/proj3_3.30d8396b.jpg";